/* Importing the React library and the useCallback, useState, and useEffect hooks. */
import { useCallback, useEffect } from 'react';

import { Outlet } from 'react-router-dom';

/* Importing the useDispatch hook from the react-redux library. */
import { useSelector, useDispatch } from 'react-redux';

// material
import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import moment from 'moment';

import { setTime } from '../features/default/defaultSlice';

// components
import Logo from '../components/Logo';

// ----------------------------------------------------------------------

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(2, 2, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0),
  },
}));

// ----------------------------------------------------------------------

export default function LogoOnlyLayout() {
  /* Importing the useDispatch hook from the react-redux library. */
  const dispatch = useDispatch();

  const currentTime = useSelector((state) => state.default.time);

  const clock = useCallback(() => {
    setInterval(() => {
      dispatch(setTime());
    }, 1000);
  }, [dispatch]);

  useEffect(() => {
    clock();
  }, [clock]);

  return (
    <>
      <HeaderStyle>
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Logo />
          <Typography variant="h3">
            {moment().format('YYYY-MM-DD')} {currentTime}
          </Typography>
        </Grid>
      </HeaderStyle>
      <Outlet />
    </>
  );
}
